import gql from 'graphql-tag';
import FoodIcon from '../assets/Label_Food.png';
import FoodIconInv from '../assets/Label_Food_inv.png';
import ShoppingIcon from '../assets/Label_Shopping.png';
import ShoppingIconInv from '../assets/Label_Shopping_inv.png';
import TicketIcon from '../assets/Label_Tickets.png';
import TicketIconInv from '../assets/Label_Tickets_inv.png';

//  ---------------------------------
export const getCategoryLogo = (cat, inv = false) => {
  switch (cat) {
    case 'F - Food and Beverage':
      return inv ? FoodIconInv : FoodIcon;
    case 'D - Ticket':
      return inv ? TicketIconInv : TicketIcon;
    default:
      return inv ? ShoppingIconInv : ShoppingIcon;
  }
};

//  ---------------------------------
export const getCategoryClass = cat => {
  switch (cat) {
    case 'F - Food and Beverage':
      return 'food-logo';
    case 'D - Ticket':
      return 'ticket-logo';
    default:
      return 'shopping-logo';
  }
};

//  ---------------------------------
export const getDrawingsQuery = (winners = false) => gql`
  query GetDrawings($input: GetDrawings!) {
    drawings(input: $input) {
      drawings {
        id
        name
        description
        drawTime
        drawingState
        enabled
        autoClaim
        groupId
        serverTime
        hasEnteredFreeTicket
        totalEntries
        totalParticipants
        allTicketsAllowed
        userInGroup
        winningPlaces {
          winningPlaces {
            place
            prize {
              id
              name
              description
              url
              category
            }
          }
        }
        ${
          winners
            ? `
          drawingWinners{
            drawingWinners{
              rank
              claimed
              user {
                userId
                displayName
              }
            }
          }`
            : ``
        }
      }
    }
  }
`;

export const getDrawingQuery = (winners = false) => gql`
  query GetDrawing($input: GetDrawing!) {
    drawing(input: $input) {
      id
      name
      description
      drawTime
      drawingState
      enabled
      autoClaim
      groupId
      serverTime
      hasEnteredFreeTicket
      totalEntries
      totalParticipants
      allTicketsAllowed
      userInGroup
      winningPlaces {
        winningPlaces {
          place
          prize {
            id
            name
            description
            url
            category
          }
        }
      }
      ${
        winners
          ? `
        drawingWinners{
          drawingWinners{
            rank
            claimed
            user {
              userId
              displayName
            }
          }
        }`
          : ``
      }
    }
  }
`;
